import useSWR from 'swr';
import { Card, Container, Row, Col } from 'react-bootstrap';
import HeroBanner from './HeroBanner';
import MarqueeText from './MarqueeText';
import PrimerConcurso from './PrimerConcurso';

const backendURL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

const fetcher = (url) => fetch(url).then((res) => res.json());

function Home() {
  const { data: grupos, error } = useSWR(`${backendURL}/api/grupos`, fetcher, {
    refreshInterval: 3000, // Refresca cada 3 segundos
  });

  if (error) return <p>Error al cargar los datos</p>;
  if (!grupos) return <p>Cargando...</p>;

  const topGrupos = grupos.slice(0, 3);

  return (
    <>
      <HeroBanner />
      <PrimerConcurso />
      <MarqueeText text="RANKING" />
      <h2 className="text-center h2text">RANKING PARCIAL</h2>
      <Container className="mt-5">
        <Row>
          {topGrupos.map((grupo, index) => (
            <Col md={4} key={grupo._id} className="cajaposicion">
              <p className="textpuesto">Puesto Nº{index + 1}</p>
              <h2 className="numerogrande">{index + 1}</h2>
              <Card className="shadow-lg border-0 grupo cardtop">
                <Card.Body>
                  <Card.Text as="div">
                    <h2>UTILERÍA <span>{grupo.nombre}</span></h2>
                    <h3>{grupo.estilo}</h3>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
}

export default Home;
